import { Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { Invsalida } from '../invinterfaces/invsalida';
import { Invencsalida } from '../invinterfaces/invencsalida';
import { Invsalidavar } from '../invinterfaces/invsalidavar';
import { InvMaearticulo } from '../invinterfaces/invmaearticulo';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { InvsalidaprodService } from '../invservicios/invsalidaprod.service';
import { InvbusquedaService } from '../invservicios/invbusqueda.service';
import { ErroresBaseDatosService } from '../../servicios/errores-base-datos.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { DatePipe } from '@angular/common';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { Usuario } from 'src/app/usuario'
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined, isNull } from 'util';
@Component({
  selector: 'app-invsalidaprod',
  templateUrl: './invsalidaprod.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InvsalidaprodComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  hmpConfiguracion: any[];
  indicador: any;
  modulo='PROD'
  posibleGuardar: boolean;
  contadorAsiento: number;
  permisoSalida: SegMaePermiso;

  salidaSeleccionada: Invsalida;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  botonPrimero: boolean;
  botonSiguiente: boolean;
  botonAnterior: boolean;
  botonUltimo: boolean;
  barraBotones2: boolean;
  barraBotones4: boolean;
  panelSalidas: boolean;
  inputsboolean: boolean;
  botonNuevoP: boolean;
  botonBorrarP: boolean;
  botonRegresarP: boolean;
  decimalesPrecioSal: number;
  decimalesCantidadSal: number;
  decimalesTotalSal: number;
  displayDialogBus: boolean;
  displayDialogBusFast: boolean;
  displayDialogAsiento: boolean;
  displayAsiContable: boolean;
  totalSalida: number;
  displayAcciones: boolean;
  displayDialogSeriales: boolean;
  displayDialogLotes: boolean;
  spin = false;
  strNumFact: any;
  strFechaSer: any;
  indice: number;
  opcion: string;
  types: SelectItem[];
  arregloBusq: any[];
  busquedaCampos: string[];
  auxiliar: number;
  tabla: string;
  where: string;
  largo: string;
  consulta: string;
  public frameworkComponents;
  rowStyle;
  defaultColDefSalida;
  rowSelection = 'multiple';
  auxreporte: number = 0;
  displayDialogReportes: boolean;
  displayDialogDocumentos = false;
  auxiliarlot = 0;
  strNombreForma: string;
  activeIndex: number = 0;
  asiento: any;
  COSENXPESO

  columnDefsSalida = [
    { // 0
      headerName: 'Bodega', field: 'BOD_CODIGO', cellEditor: 'cellPrueba',
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 10,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Artículo', field: 'ART_CODIGO', cellEditor: 'cellPrueba', width: 150,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: false,
          obligatorio: true,
          fecha: false,
          opcionbuscar: true,
          tamanocelda: 25
        }
      }
    },
    { // 2
      headerName: 'Nombre', field: 'ART_NOMBRE', cellEditor: 'cellPrueba', width: 200,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: false,
          obligatorio: true,
          fecha: false,
          tamanocelda: 80
        }
      }
    },
    { // 3
      headerName: 'Documento', field: 'DETKAR_NRODOC', cellEditor: 'cellPrueba', editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: false,
          obligatorio: true,
          fecha: false
        }
      }
    },
    { // 4
      headerName: 'Cantidad', field: 'DETKAR_CANTIDAD', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      // , editable: true,
      onCellClicked: (params) => {
        this.abrirLotes(params.data);
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 6,
          obligatorio: true,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
        }
      }
    },
    { // 5
      headerName: 'Costo', field: 'DETKAR_COSTOUNIT', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      editable: () => {
        return false;
      }
      /*cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: 6,
            obligatorio: true,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        }*/
    },
    { // 6
      headerName: 'Costo Total', field: 'DETKAR_COSTOTOTAL', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      editable: () => {
        return false;
      }
      /*cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: true,
            numerodecimales: 2,
            obligatorio: true,
            fecha: false,
            tamanocelda: 32
          }
        }*/
    }, { // 7
      headerName: 'C.Costos', field: 'CEN_CODIGO', cellEditor: 'cellPrueba',
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          opcionbuscar: true,
          tamanocelda: 35
        }
      }
    },
    // { // 8
    //   headerName: 'Cod. Centro Trabajo', field: 'CENTRA_CODIGO', cellEditor: 'cellPrueba', width: 190,
    //   // editable: true,
    //   cellEditorParams:
    //   {
    //     values: {
    //       mayusculas: false,
    //       numeros: true,
    //       alphabetic: true,
    //       saltoslinea: 0,
    //       newrow: false,
    //       numerodecimales: 0,
    //       obligatorio: true,
    //       fecha: false,
    //       clave: false,
    //       tamanocelda: 10,
    //       opcionbuscar: true
    //     }
    //   }
    // },
  ];






  constructor(public invsalidaprodService: InvsalidaprodService, private datePipe: DatePipe,
    private busquedaService: InvbusquedaService,
    private messageService: MessageService,
    private errorService: ErroresBaseDatosService,
    private confirmationService: ConfirmationService,
    private confIniciales: ConfInicialesService,
    private init: NuevoComponentService,
    private auditoriagral: AuditoriagralService,
    private utilitariosService: UtilitariosService,
    public usuario: Usuario,
    private permisosService: PermisosService,) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefSalida = {
      editable: true,
      width: 150,
      objeto: 'maesalidaprod'
    };
  }
  ngOnInit(): void {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.confIniciales.getDecimales('frmINV_ENCKARDEX').subscribe((dec) => {
      if (dec !== null) {
        dec.map((decimales) => {
          if (decimales.NUMDEC_CAMPO === 'COSTO') {
            this.decimalesPrecioSal = Number(decimales.NUMDEC_NUMDEC);
            this.invsalidaprodService.decimalesPrecioSal = this.decimalesPrecioSal;
          } else if (decimales.NUMDEC_CAMPO === 'COSTOTOTAL') {
            this.decimalesTotalSal = Number(decimales.NUMDEC_NUMDEC);
            this.invsalidaprodService.decimalesTotalSal = this.decimalesTotalSal;
          } else if (decimales.NUMDEC_CAMPO === 'CANTIDAD') {
            this.decimalesCantidadSal = Number(decimales.NUMDEC_NUMDEC);
            this.invsalidaprodService.decimalesCantidadSal = this.decimalesCantidadSal;
          }
        });

        this.columnDefsSalida[4].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.invsalidaprodService.decimalesCantidadSal,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        };

        this.columnDefsSalida[5].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.invsalidaprodService.decimalesPrecioSal,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        };
        this.aggrid.refreshColumnDefs();
      }
    });
    this.tabla = '';
    this.auxiliar = 0;
    this.busquedaCampos = [];
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonSiguiente = false;
    this.botonAnterior = false;
    this.botonUltimo = false;
    this.barraBotones2 = false;
    this.barraBotones4 = false;
    this.panelSalidas = false;
    this.botonNuevoP = true;
    this.botonBorrarP = true;
    this.botonRegresarP = true;
    this.inputsboolean = true;
    this.displayDialogReportes = false;
    this.largo = '-5800';
    this.invsalidaprodService.date1 = new Date();
    this.invsalidaprodService.hora = new Date();
    this.inputsboolean = true;
    this.invsalidaprodService.encsalidaSeleccionada[this.indicador] = {};
    this.invsalidaprodService.detkardexsarray[this.indicador] = [];
    this.salidaSeleccionada = {};
    this.contadorAsiento = 0;
    this.asiento = '';

    this.permisosService.getListaPermisos('PROD', '6', '502').subscribe((permiso) => {
      this.permisoSalida = permiso[0];
    });
    this.getConfiguracion();
    this.aggrid.hideColumn('',false)

  }
  getConfiguracion() {
    this.auditoriagral.obtenerConfiguracion1().subscribe((conf) => {
      this.hmpConfiguracion = conf;
      //CDPJ
      const ccpies = this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'CCPIES').CFG_VALOR1;
      this.COSENXPESO =(this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'COSENXPESO').CFG_VALOR1) === 1;
      //CDPJ
      // if (this.COSENXPESO === false) {
      //   this.columnDefsSalida.splice(8, 1);
        
      // }
      if (ccpies === 0 || ccpies === null || ccpies === undefined) {
        this.columnDefsSalida.splice(7, 1);
      }
      this.aggrid.refreshColumnDefs();

    });
  }
  abrirLotes(params) {
    this.salidaSeleccionada = params;
    this.auxiliarlot++;
    this.displayDialogLotes = this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO.length > 0 && this.salidaSeleccionada.ART_CADUCA === 'S';
  }
  async manejarSenales(valor) {
    if (valor !== 'Nuevo' && valor !== 'Cancelar'
      && valor !== 'Primero' && valor !== 'Anterior' && valor !== 'Siguiente' && valor !== 'Ultimo'
      && valor !== 'Buscar' && valor !== 'Imprimir' && valor !== 'AsientoVer' && valor !== 'Salir' && valor !== 'Almacenardoc') {
      // Verifica el periodo contable
      const dia = this.invsalidaprodService.date1.getDate();
      const mes = this.invsalidaprodService.date1.getMonth();
      const anio = this.invsalidaprodService.date1.getFullYear();

      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.messageService.add({
          key: 'salprod',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, fecha debe de estar dentro del período contable'
        });
        return;
      }
    }
    if (valor === 'Guardar') {
      let prodin = 0;
      let pondera=0
      const rs = await this.invsalidaprodService.ValidaEnSaOrdProd(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
      const rs1 = await this.invsalidaprodService.ValidaPonderacion(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
      if (rs !== null && rs !== undefined) {
        for (const data of rs) {
          prodin = data.NUMERO
        }
      }
      if (rs1 !== null && rs1 !== undefined) {
        for (const data of rs1) {
          pondera = data.NUMERO
        }
      }
      if (prodin > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la Orden de Producción está ingresada'
        });
        return;
      }
      if (pondera > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la entrada a la que está vinculada se encuentra ponderada '
        });
        return;
      }
      this.realizarGuardar();
    }
    if (valor === 'Borrar') {
      this.confirmarBorrarT('documento');
    }
    if (valor === 'Cancelar' || valor === 'Nuevo' || valor === 'Primero' || valor === 'Ultimo'
      || valor === 'Anterior' || valor === 'Siguiente') {
      if (valor === 'Nuevo' || valor === 'Primero' || valor === 'Ultimo'
        || valor === 'Anterior' || valor === 'Siguiente') {
        console.log(!this.existeAsiento())
        if (!this.existeAsiento()) {
          return;
        }
      }
      console.log('valor', valor)
      this.mostrarSalida(valor);
    }
    if (valor === 'Buscar') {
        this.opcion = 'BUSQUEDA';
        this.types = [
          { label: 'Número', value: 'KAR_NRO' },
          { label: 'Fecha', value: 'KAR_FECHA' },
          { label: 'Comentario', value: 'KAR_COMENTARIO' },
          { label: 'Comprobante', value: 'KAR_NROCOMPROBANTE' },
          { label: 'No. Asiento', value: 'ASI_NRO' },
          { label: 'ORDEN PROD', value: 'ENCORDPRO_NUMERO' },
          { label: 'Origen', value: 'KAR_ORIGEN' },
        ];
        //CDPJ
        this.busquedaCampos = ['', '', '', '', '', '', '']
        this.tabla = 'INV_ENCKARDEX';
        
          this.where = 'KAR_TIPO = \'SA\' AND KAR_ORIGEN = \'PROD\'';
        
        this.busquedaService. busquedaInvEncKardex2NEW('PROD').subscribe((res: any[]) => {
          this.arregloBusq = res;
          this.arregloBusq.map((bus) => {
            bus.KAR_FECHA = this.datePipe.transform(bus.KAR_FECHA, 'dd/MM/yyyy');
          });
          this.displayDialogBusFast = true;
          this.spin=false;
        });
    }

    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Asiento') {
      // if (this.modulo !== 'PROD') {
      //   let totalvar: number;
      //   totalvar = Number(this.calcularTotalVarios());
      //   if (Number(this.salidaService.totalSalidaarray[this.indicador]) !== totalvar) {
      //     this.messageService.add({
      //       key: 'sal',
      //       severity: 'error',
      //       summary: 'Generar asiento',
      //       detail: 'El total de varios es diferente al total del documento.' +
      //         'No se puede generar el Asiento contable'
      //     });
      //   } else {
      //     await this.generarAsiento();
      //   }
      // } else {
        await this.generarAsientoProd();
      //}
    }

    if (valor === 'AsientoVer') {
      //if(this.modulo !== 'PROD'){
      this.invsalidaprodService.getAsiento(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).subscribe((res) => {
        this.asiento = res[0].ASI_NRO;
        if (this.asiento === null) {
          this.asiento = '';
        }
        if (this.asiento === '') {
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Visualizacion de Asiento Contable',
            detail: 'Esta salida no tiene un asiento contable'
          });
        } else {
          this.auxiliar++;
          // this.displayDialogAsiento = true;
          this.displayAsiContable = true;
        }
      });
      //}
    }
    if (valor === 'Salir') {

        this.init.tabs.splice(this.init.tabindex, 1);
    }
  }

  async generarAsientoProd() {
    try {
      await this.invsalidaprodService.generarAsientoProdProm(this.invsalidaprodService.encsalidaSeleccionada[this.indicador], this.usuario.identificacion);
      const resp = await this.invsalidaprodService.getAsientoProm(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);

      await this.auditoriagral.registrarAuditoria('CON_ENCASI_L', '/Numero:'+this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO + 
      '/AsiNumero:'+resp[0].ASI_NRO+ '/INV-PROD' , 'A',
      this.usuario.identificacion, '01', '', '', '', '').toPromise()

      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO = resp[0].ASI_NRO;
      this.messageService.add({
        key: 'salprod',
        summary: 'Insertar Asiento Contable',
        severity: 'success',
        detail: 'El Asiento contable se genero correctamente'
      });
      this.spin = false//CDPJ

    } catch (err) {
      let mensaje: string;
      mensaje = this.errorService.generarMensajeError(err.error.substr(0, 9));
      this.messageService.add({
        key: 'salprod',
        severity: 'error',
        summary: 'Inserción de Asiento Contable',
        detail: mensaje
      });
      this.spin = false//CDPJ
    }
  }
  confirmarBorrarT(valor: string) {
    let mensaje: string;
    let metodo: number;
    let llave: string;
    switch (valor) {
      case 'registro':
        mensaje = 'Está seguro de eliminar el Registro?';
        metodo = 0;
        llave = 'confirmarSalprod';
        break;
      case 'registroV':
        mensaje = 'Está seguro de eliminar el Registro?';
        metodo = 1;
        llave = 'confirmarSalprod';
        break;
      case 'documento':
        mensaje = 'Está seguro de eliminar el Documento?';
        metodo = 2;
        llave = 'confirmarSalprod';
        break;
      case 'asiento':
        mensaje = 'El documento no tiene Asiento Contable. Desea eliminar el documento?';
        metodo = 3;
        llave = 'confSinAsiento';
        break;
      case 'cambio':
        mensaje = 'Existen cambios, desea guardarlos?';
        metodo = 4;
        llave = 'confirmarSalprod';
    }
    this.confirmationService.confirm({
      message: mensaje,
      header: 'Información',
      icon: 'pi pi-question',
      key: llave,
      accept: () => {
        if (metodo === 0) {
          this.enviarBorrarSalida();
          return;
        } else if (metodo === 1) {
          

          return;
        } else if (metodo === 2) {
          if (this.permisoSalida.PERELIMACION === 1) {
            this.borrarEncSalida();
          } else if (this.permisoSalida.PERELIMACION === 0) {
            this.messageService.add({
              key: 'salprod',
              severity: 'error',
              summary: 'Eliminación Salida',
              detail: 'El usuario no tiene permisos de eliminación, acción denegada'
            });
          }
          return;
        } else if (metodo === 3) {
          if (this.permisoSalida.PERELIMACION === 1) {
            this.confirmarBorrarT('documento');
          } else if (this.permisoSalida.PERELIMACION === 0) {
            this.messageService.add({
              key: 'salprod',
              severity: 'error',
              summary: 'Eliminación Salida',
              detail: 'El usuario no tiene permisos de eliminación, acción denegada'
            });
          }
          return;
        } else if (metodo === 4) {
          this.manejarSenales('Guardar');
          return;
        }
      },
      reject: () => {
        if (metodo === 4) {
         // this.verificarAsiento();
        }
      }
    });
  }
  async enviarBorrarSalida() {

    if (this.salidaSeleccionada.DETKAR_LINEA === 0) {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonNuevoP = false;
      this.botonBorrarP = false;
      this.messageService.add({
        key: 'salprod',
        severity: 'success',
        summary: 'Eliminación Salida',
        detail: 'La salida seleccionada se eliminó correctamente'
      });
      this.invsalidaprodService.detkardexsarray[this.indicador] = this.invsalidaprodService.detkardexsarray[this.indicador].filter((val, j) => j !==
            this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(this.salidaSeleccionada));
      //CDPJ
      this.invsalidaprodService.calcularTotal();

      return;
    } else {
      let prodin = 0;
      let pondera=0
      const rs = await this.invsalidaprodService.ValidaEnSaOrdProd(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
      const rs1 = await this.invsalidaprodService.ValidaPonderacion(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
      if (rs !== null && rs !== undefined) {
        for (const data of rs) {
          prodin = data.NUMERO
        }
      }
      if (rs1 !== null && rs1 !== undefined) {
        for (const data of rs1) {
          pondera = data.NUMERO
        }
      }
      if (prodin > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la Orden de Producción está ingresada'
        });
        return;
      }
      if (pondera > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la entrada a la que está vinculada se encuentra ponderada '
        });
        return;
      }
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonNuevoP = false;
      this.botonBorrarP = false;
      let contador = 0;
      let i = 0;
      if (pondera > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la entrada a la que está vinculada se encuentra ponderada '
        });
        return;
      }
      do {
        if (this.salidaSeleccionada === this.invsalidaprodService.detkardexsarray[this.indicador][i]) {
          contador++;
        }
        i++;
      } while (this.invsalidaprodService.detkardexsarray[this.indicador].length > i);
      if (contador === 1) {
        this.invsalidaprodService.borrarSalida(this.salidaSeleccionada).subscribe(() => {
          this.messageService.add({
            key: 'salprod',
            severity: 'success',
            summary: 'Eliminación de Salida',
            detail: 'La salida se eliminó correctamente'
          });
          this.auditoriagral.registrarAuditoria('INV_DETKARDEX', this.salidaSeleccionada.KAR_NRO + '/' + String(this.salidaSeleccionada.ART_CODIGO) + '/cant/' + this.salidaSeleccionada.DETKAR_CANTIDAD + '/costo/' + this.salidaSeleccionada.DETKAR_COSTOTOTAL
          +'/CenTrab:'+this.salidaSeleccionada.CENTRA_CODIGO
          , 'E',
            this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
            });
          this.invsalidaprodService.detkardexsarray[this.indicador] = this.invsalidaprodService.detkardexsarray[this.indicador].filter((val, j) => j !==
            this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(this.salidaSeleccionada));
          //CDPJ
          this.invsalidaprodService.calcularTotal();
          this.botonNuevoP = false;
        }, error1 => {
          let mensaje: string;
          mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Eliminación de Salida',
            detail: mensaje
          });
        });
      } else if (contador !== 1) {
        this.invsalidaprodService.detkardexsarray[this.indicador] = this.invsalidaprodService.detkardexsarray[this.indicador].filter((val, j) => j !==
          this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(this.salidaSeleccionada));
      }
    }


  }

  cerrarReportes() {
    this.displayDialogReportes = false;
  }
  cerrarLotes() {
    this.displayDialogLotes = false;
  }
  async realizarGuardar() {
    //CDPJ
    let errores = 0;
    this.spin = true//CDPJ
    const ccpies = this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'CCPIES').CFG_VALOR1;
    this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefSalida.objeto].setFocusedCell(this.invsalidaprodService.detkardexsarray[this.indicador].length - 1, 'DETKAR_COSTOUNIT');
    this.aggrid.refreshaggrid(this.invsalidaprodService.detkardexsarray[this.indicador], this.defaultColDefSalida.objeto);
    //CDPJ
    if ((this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO === null || this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO === undefined ||
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO === '') && this.modulo === 'PROD') {
      this.messageService.add({
        key: 'salprod',
        severity: 'error',
        summary: 'Guardar Salida',
        detail: 'Ingrese el número de la orden de producción.'
      });
      this.spin = false//CDPJ
      errores = errores + 1;
      return;
    }
    if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NROCOMPROBANTE !== '') {
      await Promise.all(this.invsalidaprodService.detkardexsarray[this.indicador].map(async (entrada) => {
        let bod_codigo = 0
        //const rsdata: any = await this.salidaService.encontrarArtCntaySer(entrada.ART_CODIGO, 'A');
        const rsdata = await this.invsalidaprodService.erBodCodigo1(entrada.ART_CODIGO, 'A', entrada.BOD_CODIGO);
        let strCodigo = 0;
        if (rsdata !== null) {
          for (const rs of rsdata) {
            strCodigo = rs.NUMERO;
            bod_codigo = rs.BOD_CODIGO;
          }
        }
        if (ccpies === 1) {
          if (entrada.CEN_CODIGO === '') {
            this.messageService.add({
              key: 'salprod',
              severity: 'error',
              summary: 'Guardar Salida',
              detail: 'Ingrese el centro de costos'
            });
            this.spin = false//CDPJ
            errores = errores + 1;
          }

        }
        if (entrada.ART_CODIGO === '') {
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Guardar Salida',
            detail: 'Ingrese el código del artículo'
          });
          this.spin = false//CDPJ
          errores = errores + 1;
        }
        //CDPJ
        if (strCodigo === 0) {//CDPJ
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Información',
            detail: 'El artículo ' + entrada.ART_CODIGO + ' no existe'
          });
          this.spin = false//CDPJ
          errores++;
        }
        if (entrada.BOD_CODIGO === null || entrada.BOD_CODIGO === '' || entrada.BOD_CODIGO === undefined) {
          this.messageService.add({
            key: 'salprod',
            severity: 'warn',
            summary: 'Información',
            detail: 'Error, Código de la bodega está vacío'
          });
          this.spin = false//CDPJ
          errores++;
        }
        if (entrada.BOD_CODIGO !== null && entrada.BOD_CODIGO !== '' && entrada.BOD_CODIGO !== undefined) {
          if (bod_codigo === 0) {
            this.messageService.add({
              key: 'salprod',
              severity: 'warn',
              summary: 'Información',
              detail: 'Error, Código de la bodega ' + entrada.BOD_CODIGO + 'es incorrecto.'
            });
            this.spin = false//CDPJ
            errores++;
          }
        }
      }));
      console.log(errores)
      if (errores === 0) {
        if (this.salidaSeleccionada.BOD_CODIGO === undefined) {
          this.invsalidaprodService.detkardexsarray[this.indicador] = this.invsalidaprodService.detkardexsarray[this.indicador].filter((val, j) => j !==
            this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(this.salidaSeleccionada));
          this.botonNuevoP = false;
          if (this.invsalidaprodService.detkardexsarray[this.indicador].length !== 0) {
            this.verificarCantidadDisponible();
          } else {
          }
        } else {
          this.verificarCantidadDisponible();
        }
      }
    } else {
      this.messageService.add({
        key: 'salprod',
        severity: 'error',
        summary: 'Error',
        detail: 'El número de comprobante es obligatorio',
      });
      this.spin = false//CDPJ
    }
  }
  verificarCantidadDisponible() {
    for (const i of this.invsalidaprodService.detkardexsarray[this.indicador]) {
      if (i.DETKAR_LINEA === 0) {
        let cantidadTabla: number;
        let cantidadExistente: number;
        let cantidadGuardada: number;
        cantidadTabla = 0;
        cantidadGuardada = 0;
        cantidadExistente = 0;
        cantidadTabla = this.cantidadArticulosTabla(i.ART_CODIGO, i.BOD_CODIGO);//GSRF
        cantidadGuardada = i.CANTIDAD_GUARDADA;
        cantidadExistente = i.CANTIDAD_DISPONIBLE + cantidadGuardada;
        if (cantidadExistente < cantidadTabla) {
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'ingreso cantidad',
            detail: 'La existencia del Artículo ' + i.ART_CODIGO + ' es ' + cantidadExistente
              + '. La cantidad de la Salida no puede ser mayor a la Existencia...'
          });
          this.posibleGuardar = false;
          this.spin = false//CDPJ
          break;
        } else {
          this.posibleGuardar = true;
        }
      } else {
        let cantidadTabla: number;
        let cantidadExistente: number;
        let cantidadGuardada: number;
        cantidadTabla = 0;
        cantidadGuardada = 0;
        cantidadExistente = 0;
        cantidadTabla = this.cantidadArticulosTabla(i.ART_CODIGO, i.BOD_CODIGO);//GSRF
        cantidadGuardada = i.CANTIDAD_GUARDADA;
        cantidadExistente = i.CANTIDAD_DISPONIBLE + cantidadGuardada;
        if (cantidadExistente < cantidadTabla) {
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'ingreso cantidad',
            detail: 'La existencia del Artículo ' + i.ART_CODIGO + ' es ' + cantidadExistente
              + '. La cantidad de la Salida no puede ser mayor a la Existencia...'
          });
          this.posibleGuardar = false;
          this.spin = false//CDPJ
          break;
        } else {
          this.posibleGuardar = true;
        }
      }
    }
    if (this.posibleGuardar === true) {
      this.guardar();
    }
  }
  cantidadArticulosTabla(codArticulo, bodcodigo) {
    let cantidadT: number;
    cantidadT = 0;
    for (const i in this.invsalidaprodService.detkardexsarray[this.indicador]) {
      if (this.invsalidaprodService.detkardexsarray[this.indicador][i].ART_CODIGO === codArticulo &&
        this.invsalidaprodService.detkardexsarray[this.indicador][i].BOD_CODIGO === bodcodigo) {
        cantidadT = cantidadT + Number(this.invsalidaprodService.detkardexsarray[this.indicador][i].DETKAR_CANTIDAD);
      }
    }
    return cantidadT;
  }
  async guardar() {
    if (this.activeIndex === 0) {
      await this.guardarSalida();


    } else if (this.activeIndex === 1) {
      await this.guardarSalida();


    } else {
      return;
    }
  }
  async guardarSalida() {
    //GSRF
    this.spin = true;
 
    //CDPJ
    this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefSalida.objeto].setFocusedCell(this.invsalidaprodService.detkardexsarray[this.indicador].length - 1, 'DETKAR_COSTOUNIT');
    this.aggrid.refreshaggrid(this.invsalidaprodService.detkardexsarray[this.indicador], this.defaultColDefSalida.objeto);
    this.invsalidaprodService.calcularTotal();
    const centrotrab = Array.from(new Set(this.invsalidaprodService.encsalidaSeleccionada.map(item => String(item.CENTRA_CODIGO)).filter(x => x !== null && String(x).trim() !== '')));
    const data = await this.invsalidaprodService.validacentrabjo(centrotrab,this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO)
      //CDPJ
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefSalida.objeto].setFocusedCell(this.invsalidaprodService.detkardexsarray[this.indicador].length - 1, 'DETKAR_COSTOUNIT');
      this.invsalidaprodService.calcularTotal();

      //GSRF
      if (this.modulo === 'PROD') {
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_ORIGEN = 'PROD';
      } else {
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_ORIGEN = 'ES_INV';
      }
      //GSRF
      let hora;
      let minutos;
      hora = this.invsalidaprodService.hora.getHours();
      minutos = this.invsalidaprodService.hora.getMinutes();
      if (hora.toString().length === 1) { // poniendo el formato 00
        hora = '0' + hora;
      } else if (minutos.toString().length === 1) {
        minutos = '0' + minutos;
      }
      // if (this.COSENXPESO) {
      //   const pocentaje=this.invsalidaprodService.calcularpocentaje();
      //   if (pocentaje!==100) {
      //     this.messageService.add({
      //       key: 'salprod',
      //       severity: 'error',
      //       summary: 'Información',
      //       detail: 'La sumatoria de los porcentajes debe ser siempre del 100%'
      //     });
      //     this.spin=false;
      //     return;
      //   }
        
      // }
      if (data !== null && Object.keys(data).length > 0) {
        if (data.length > 0) {
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes centros de trabajo, '+
             'por favor revisar que estén regitrados en la pestaña de Centros de trabajo, en el módulo de ordenes de producción procesos ' + data.join(", ")
          });
          this.spin = false
          return;
        }
      }
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA = hora + ':' + minutos;
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_FECHA = this.datePipe.transform(this.invsalidaprodService.date1, 'dd/MM/yyyy');
      console.log(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO)
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO !== '' && this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO !== undefined && this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO !== null) {
        this.invsalidaprodService.actualizarEncSalida(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).subscribe(async () => {
          this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', String(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO), 'A',
            this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
            });

          if (this.invsalidaprodService.detkardexsarray[this.indicador].length !== 0) {
            for (const salida of this.invsalidaprodService.detkardexsarray[this.indicador]) {
              salida.KAR_NRO = this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO;
              salida.CENTRA_CODIGO=isNullOrUndefined(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO)?'':this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO
              //salida.DETKAR_COSTOTOTAL = Number(salida.DETKAR_COSTOUNIT) * Number(salida.DETKAR_CANTIDAD);
              // salida.DETKAR_PORCENTAJE=Number(salida.DETKAR_PORCENTAJE)
              //this.salidaService.insertarSalida(salida).subscribe((resp2) => {
              const res1 = await this.invsalidaprodService.insertarSalida(salida).toPromise()//.subscribe((res1) => {
              if (this.invsalidaprodService.detkardexsarray[this.indicador][this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(salida)].DETKAR_LINEA === 0) {
                console.log('Esta es la respuesta de la linea cuando es nueva');
                // console.log(resp2[0]);
                // const detKarLinea = JSON.stringify(resp2[0]);
                // this.obtenerDetKarLinea(detKarLinea, salida);
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', salida.KAR_NRO + '/' + String(salida.ART_CODIGO) + '/cant/' + salida.DETKAR_CANTIDAD+'/cosuni/'+salida.DETKAR_COSTOUNIT + '/costotal/' + salida.DETKAR_COSTOTOTAL
                +'/CenTrab:'+salida.CENTRA_CODIGO, 'I',
                  this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
                  });
              } else {
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', salida.KAR_NRO + '/' + String(salida.ART_CODIGO) + '/cant/' + salida.DETKAR_CANTIDAD+'/cosuni/'+salida.DETKAR_COSTOUNIT + '/costotal/' + salida.DETKAR_COSTOTOTAL
                +'/CenTrab:'+salida.CENTRA_CODIGO, 'A',
                  this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
                  });
              }
              for (const rs of res1) {
                salida.DETKAR_LINEA = rs[':B1']
              }

              //.subscribe(() => {
              await this.obtenerCantGuaradadoDisponible(salida, this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO);
              //});
              //});
            }
            await this.generarAsientoProd();
            await this.invsalidaprodService.actualizarKardex_en_sa(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).toPromise()
            this.deshabilitarBotonesGuardar();
            
            this.messageService.add({
              key: 'salprod',
              severity: 'success',
              summary: 'Actualización de Salida',
              detail: 'Se actualizó la salida correctamente'
            });

            //CDPJ
            this.spin = false//CDPJ
            this.invsalidaprodService.calcularTotal();
          } else {
            this.spin=false;
            return;
          }
          
        }, error1 => {
          let mensaje: string;
          mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Actualización de Salida',
            detail: mensaje
          });
          this.spin = false//CDPJ
        });
        // Este es el código para insertar un nuevo encabezado de salida
      } else {
        //CDPJ
        this.invsalidaprodService.calcularTotal();
        let hora1;
        let minutos1;
        hora1 = this.invsalidaprodService.hora.getHours();
        minutos1 = this.invsalidaprodService.hora.getMinutes();
        console.log('minutos1', minutos1)
        console.log('minutos1.toString().length', minutos1.toString().length)
        if (hora1.toString().length === 1) { // poniendo el formato 00
          hora1 = '0' + hora1;
        } else if (minutos1.toString().length === 1) {
          minutos1 = '0' + minutos1.toString();
        }
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA = hora1 + ':' + minutos1;
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_FECHA = this.datePipe.transform(this.invsalidaprodService.date1, 'dd/MM/yyyy');

        // console.log('Esto se guarda');
        // console.log(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
        this.invsalidaprodService.insertarEncSalida(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).subscribe(async (res) => {

          this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO = JSON.stringify(res[0]).substr(8, 12);
          this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', String(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO), 'I',
            this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
            });

          if (this.invsalidaprodService.detkardexsarray[this.indicador].length !== 0) {
            for (const salida of this.invsalidaprodService.detkardexsarray[this.indicador]) {

              salida.KAR_NRO = this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO;
              salida.CENTRA_CODIGO=isNullOrUndefined(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO)?'':this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO
              // salida.DETKAR_COSTOTOTAL = (Number(salida.DETKAR_COSTOUNIT) *
              //   Number(salida.DETKAR_CANTIDAD)) + '';
                // salida.DETKAR_PORCENTAJE=Number(salida.DETKAR_PORCENTAJE)
              const res1 = await this.invsalidaprodService.insertarSalida(salida).toPromise()//.subscribe((res1) => {
              for (const rs of res1) {
                salida.DETKAR_LINEA = rs[':B1']
              }
              //const detKarLinea = JSON.stringify(res1[0]);
              if (this.invsalidaprodService.detkardexsarray[this.indicador][this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(salida)].DETKAR_LINEA === 0) {
                console.log('Esta es la respuesta de la linea cuando es nueva');
                // console.log(resp2[0]);
                // const detKarLinea = JSON.stringify(resp2[0]);
                // this.obtenerDetKarLinea(detKarLinea, salida);
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', salida.KAR_NRO + '/' + String(salida.ART_CODIGO) + '/cant/' + salida.DETKAR_CANTIDAD+'/cosuni/'+salida.DETKAR_COSTOUNIT + '/costotal/' + salida.DETKAR_COSTOTOTAL
                +'/CenTrab:'+salida.CENTRA_CODIGO, 'I',
                  this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
                  });
              } else {
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', salida.KAR_NRO + '/' + String(salida.ART_CODIGO) + '/cant/' + salida.DETKAR_CANTIDAD+'/cosuni/'+salida.DETKAR_COSTOUNIT + '/costotal/' + salida.DETKAR_COSTOTOTAL
                +'/CenTrab:'+salida.CENTRA_CODIGO, 'A',
                  this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
                  });
              }
              //this.obtenerDetKarLinea(detKarLinea, salida);
              //this.salidaService.actualizarKardex_en_sa(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).subscribe(() => {
              await this.obtenerCantGuaradadoDisponible(salida, this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO);
              //});
              //});

            }
          } else {
            this.spin=false;
            return;
          }
          this.messageService.add({
            key: 'salprod',
            severity: 'success',
            summary: 'Inserción de Salida',
            detail: 'Se ingresó la salida correctamente'
          });
          this.spin = false//CDPJ
          await this.generarAsientoProd();
          await this.invsalidaprodService.actualizarKardex_en_sa(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).toPromise()
          this.deshabilitarBotonesGuardar();
         
          this.contadorAsiento = 1;
        }, error1 => {
          let mensaje: string;
          console.log(error1);
          mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
          this.messageService.add({
            key: 'salprod',
            severity: 'error',
            summary: 'Inserción de Salida',
            detail: mensaje
          });
          this.spin = false//CDPJ
        });
      }
      // cdpj
      this.botonRegresarP = false;

    
  }
  obtenerCantGuaradadoDisponible(salida, nroDocumento) {
    this.invsalidaprodService.getcantidadGrabadaDoc(nroDocumento, salida.ART_CODIGO).subscribe((res3) => {
      salida.CANTIDAD_GUARDADA = Number(res3[0].CANTGRABADA);
      this.invsalidaprodService.getExistenciaArt('FAC', salida.ART_CODIGO, salida.BOD_CODIGO, this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_FECHA, this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA).subscribe((res4) => {
        salida.CANTIDAD_DISPONIBLE = res4[0].ARTEXISTENCIA;
      });
    });
  }
  deshabilitarBotonesGuardar() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonUltimo = false;
    this.botonSiguiente = false;
    this.botonAnterior = false;
    this.barraBotones2 = false;
    this.botonNuevoP = false;
    this.botonBorrarP = false;
    this.botonRegresarP = true;

  }
  existeAsiento() {
    let bolExiste = false;
    if (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'DOCSINASI').CFG_VALOR1 === 0) {
      let bolSaldoIni = false;
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO === null || this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO === undefined) {
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO = '';
      }

      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO === null || this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO === undefined) {
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO = '';
      }

      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO.length === 0 &&
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO.length > 0 && !bolSaldoIni) {
        this.confirmationService.confirm({
          message: 'El documento no tiene Asiento Contable.' +
            ' Desea eliminar el documento?',
          header: 'Pregunta',
          icon: 'pi pi-exclamation-triangle',
          key: 'confirmarSalprod',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => {
            this.confirmationService.close();
            this.borrarEncSalida();
          },
          reject: () => {
            this.confirmationService.close();
          }
        });
      } else {
        bolExiste = true;
      }
    } else {
      bolExiste = true;
    }
    return bolExiste;
  }
  async borrarEncSalida() {
    //validar que la salida no esté en una orden de producción ya ingresada
    let prodin = 0;
      let pondera=0
      const rs = await this.invsalidaprodService.ValidaEnSaOrdProd(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
      const rs1 = await this.invsalidaprodService.ValidaPonderacion(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]);
      if (rs !== null && rs !== undefined) {
        for (const data of rs) {
          prodin = data.NUMERO
        }
      }
      if (rs1 !== null && rs1 !== undefined) {
        for (const data of rs1) {
          pondera = data.NUMERO
        }
      }
      if (prodin > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la Orden de Producción está ingresada'
        });
        return;
      }
      if (pondera > 0) {
        this.messageService.add({
          key: 'salprod',
          severity: 'error',
          summary: 'Eliminación de Salida',
          detail: 'No se puede editar la salida ya que la entrada a la que está vinculada se encuentra ponderada '
        });
        return;
      }
    try {
      await this.invsalidaprodService.borrarEncSalida(this.invsalidaprodService.encsalidaSeleccionada[this.indicador]).toPromise()//subscribe(() => {
      this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO, 'E',
        this.usuario.identificacion, '01', '', '', '', '').subscribe(() => {
        });
      let numero;
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO !== undefined || this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO !== '') {
        numero = this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ASI_NRO;
        if (numero !== undefined || numero !== '') {
          await this.invsalidaprodService.eliminarAsientoCont(numero).toPromise()//.subscribe(() => {
          //});
        }
      }
      this.messageService.add({
        key: 'salprod',
        severity: 'success',
        summary: 'Eliminación de Salida',
        detail: 'Se eliminó la salida correctamente'
      });
      this.salidaSeleccionada = {};
      this.invsalidaprodService.date1 = new Date();
      this.invsalidaprodService.hora = new Date();
      this.limpiardatos();
    } catch (error1) {
      let mensaje: string;
      mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
      this.messageService.add({
        key: 'salprod',
        severity: 'error',
        summary: 'Eliminicación de Salida',
        detail: mensaje
      });
    }
  }
  async mostrarSalida(valor) {
    let strCondicion = 'KAR_NRO IS NOT NULL AND COM_CODIGO = \'01\'';
    let strTipo = ''

    if (valor === 'Primero') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      strTipo = 'P';
      this.consultarregistro(strTipo, strCondicion);
    }

    if (valor === 'Ultimo') {
    
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = true;
      this.botonUltimo = true;
      strTipo = 'U';
      this.consultarregistro(strTipo, strCondicion);
    }

    if (valor === 'Anterior') {
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      
      strTipo = 'A';
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO.length > 0) {
        strCondicion = strCondicion + ' AND KAR_NRO < \''
          + this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO + '\'';
      } else {
        strTipo = 'P';
      }
      this.consultarregistro(strTipo, strCondicion);
    }

    if (valor === 'Siguiente') {
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      strTipo = 'S';
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO.length > 0) {
        strCondicion = strCondicion + ' AND KAR_NRO > \''
          + this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO + '\' AND KAR_NRO LIKE \''
          + this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO.substr(0, 3) + '%\'';
      } else {
        strTipo = 'U';
      }
      this.consultarregistro(strTipo, strCondicion);
    } if (valor === 'Nuevo') {
      this.realizarNuevo();
    } if (valor === 'Cancelar') {
      this.botonNuevo = false;
      console.log(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO);
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO === '' || this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO === undefined
        || this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO === null) {
        this.limpiardatos();
      } else {
        this.botonRegresarP = true;
        this.botonNuevoP = false;
        this.botonBorrarP = false;
        await this.mostrarDatos(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO)
      }
    }
  }
  consultarregistro(strTipo, strCondicion) {
    this.invsalidaprodService.seleccionarRegistro(strTipo, ' ', strCondicion).subscribe((datos: any[]) => {
      if (datos !== null) {
        this.mostrarDatos(datos[0].KAR_NRO);
      }
    }, error1 => {
      const error = this.errorService.generarMensajeError(error1.error.substr(0, 9));
      this.messageService.add({
        key: 'salprod',
        severity: 'error',
        summary: 'Error',
        detail: error
      });
    });
  }
  async mostrarDatos(KAR_NRO) {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.barraBotones2 = false;
    this.barraBotones4 = false;
    this.botonNuevoP = false;
    this.botonBorrarP = false;
    this.botonRegresarP = false;

    let fecha = '';
    let hora = '';
    let resp = []
    resp = await this.invsalidaprodService.getencKardex(KAR_NRO);
    if (resp === null) {
      this.init.disabledtab = false;
      return;
    }
    for (const data of resp) {
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador] = data
      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_FECHA === undefined) {
        return;
      }
      this.invsalidaprodService.date1 = new Date(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_FECHA);
      this.invsalidaprodService.hora = new Date(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_FECHA);

      this.invsalidaprodService.encordprod=this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO;
      this.invsalidaprodService.encchkcentra=this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_CHKCENTRA;
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO=isNullOrUndefined(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO)?'':
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO

      if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.toString().length === 4) {
        const separador = ':';
        const arregloHora = this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.toString().split(separador);
        console.log(arregloHora);
        for (let i = 0; i < arregloHora.length; i++) {
          if (arregloHora[i].length !== 2) {
            arregloHora[i] = '0' + arregloHora[i];
          }
        }
        const horaDefinitiva = arregloHora.join(':');
        console.log(horaDefinitiva);
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA = horaDefinitiva;
      } else if (this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.toString().length === 3) {
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA = '0' + this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.toString();
        this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA = this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.toString().substr(0, 2) + '0'
          + this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.toString().substr(3, 1);
      }
      this.invsalidaprodService.hora.setHours(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.substr(0, 2));
      this.invsalidaprodService.hora.setMinutes(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_HORA.substr(3, 2));
      this.invsalidaprodService.consultarDetKardex(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO).subscribe((res) => {
        this.invsalidaprodService.detkardexsarray[this.indicador] = res;
        this.invsalidaprodService.detkardexsarray[this.indicador].map((salida) => {
          salida.DETKAR_COSTOUNIT = salida.DETKAR_COSTOUNIT.toFixed(this.decimalesPrecioSal);
          salida.DETKAR_CANTIDAD = salida.DETKAR_CANTIDAD.toFixed(this.decimalesCantidadSal);
          salida.CEN_CODIGO = salida.CEN_CODIGO === null || salida.CEN_CODIGO === undefined ? '' : salida.CEN_CODIGO;//CDPJ
          salida.CENTRA_CODIGO = isNullOrUndefined(salida.CENTRA_CODIGO)?'':salida.CENTRA_CODIGO
        });
        // colocar en cada articulo su cantidad guardada y existente
        fecha = this.datePipe.transform(this.invsalidaprodService.date1, 'dd/MM/yyyy');
        hora = this.datePipe.transform(this.invsalidaprodService.hora, 'HH:mm');
        for (const i of this.invsalidaprodService.detkardexsarray[this.indicador]) {
          this.invsalidaprodService.getcantidadGrabadaDoc(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO, i.ART_CODIGO).subscribe((res2) => {
            i.CANTIDAD_GUARDADA = res2[0].CANTGRABADA;
            this.invsalidaprodService.getExistenciaArt('FAC', i.ART_CODIGO, i.BOD_CODIGO, fecha, hora).subscribe((res3) => {
              i.CANTIDAD_DISPONIBLE = res3[0].ARTEXISTENCIA;
            });
          });
        }
        this.invsalidaprodService.calcularTotal();
      });
    }
  }
  async limpiardatos() {
    this.tabla = '';
    this.auxiliar = 0;
    this.busquedaCampos = [];
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonSiguiente = false;
    this.botonAnterior = false;
    this.botonUltimo = false;
    this.barraBotones2 = false;
    this.barraBotones4 = false;
    this.panelSalidas = false;
    //this.panelVarios = false;
    this.botonNuevoP = true;
    this.botonBorrarP = true;
    this.botonRegresarP = true;
    // this.botonNuevoPV = true;
    // this.botonBorrarPV = true;
    // this.botonRegresarPV = true;
    this.displayDialogBus = false;
    this.displayDialogBusFast = false;
    this.displayDialogAsiento = false;
    this.displayAsiContable = false;
    this.displayAcciones = false;
    this.displayDialogSeriales = false;
    this.displayDialogLotes = false;
    this.totalSalida = 0;

    this.invsalidaprodService.detkardexsarray[this.indicador] = [];
    this.indice = 0;
    this.invsalidaprodService.date1 = new Date();
    this.invsalidaprodService.hora = new Date();
    this.salidaSeleccionada = {};
    this.inputsboolean = true;
    this.largo = '500';
    this.consulta = '';
    this.contadorAsiento = 0;
  }
  realizarNuevo() {

    this.tabla = '';
    this.auxiliar = 0;
    this.busquedaCampos = [];
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonSiguiente = false;
    this.botonAnterior = false;
    this.botonUltimo = false;
    this.barraBotones2 = false;
    this.barraBotones4 = false;
    this.panelSalidas = false;
    //this.panelVarios = false;
    this.botonNuevoP = true;
    this.botonBorrarP = true;
    this.botonRegresarP = true;
    // this.botonNuevoPV = true;
    // this.botonBorrarPV = true;
    // this.botonRegresarPV = true;
    this.displayDialogBus = false;
    this.displayDialogBusFast = false;
    this.displayDialogAsiento = false;
    this.displayAsiContable = false;
    this.displayAcciones = false;
    this.displayDialogSeriales = false;
    this.displayDialogLotes = false;
    this.totalSalida = 0;
    // this.contadorLineaVar = 0;
    // this.saldoTotalVarios = 0;
    this.invsalidaprodService.detkardexsarray[this.indicador] = [];
    //this.activeIndex = 0;
    // this.invsalidaprodService.detkardexsvararray[this.indicador] = [];
    this.indice = 0;
    // this.artNombre = {};
    // this.checkSaldoI = false;
    // this.opcion = '';
    this.invsalidaprodService.date1 = new Date();
    this.invsalidaprodService.hora = new Date();
    this.salidaSeleccionada = {};
    //this.invsalidaprodService.encsalidaSeleccionada[this.indicador] = {};
    this.inputsboolean = true;
    this.largo = '500';
    // this.asiento = '';
    // this.tieneAsiento = false;
    this.consulta = '';
    this.asiento = '';
    //this.obtenerEncSalidas();
    this.contadorAsiento = 0;
    //this.panelVarios = true;
    this.inputsboolean = false;
    this.botonNuevoP = false;
    this.botonBorrarP = false;
    let encSalida: Invencsalida;
    encSalida = {
      KAR_NRO: '',
      KAR_TIPO: 'SA',
      KAR_NROCOMPROBANTE: '',
      COM_CODIGO: '01',
      TIPDIA_CODIGO: 'SA',
      USUIDENTIFICACION: this.usuario.identificacion,
      KAR_NO_KARDEX: '0',
      KAR_SALDOINI: '',
      KAR_ESTADO: '',
      ENCORDPRO_NUMERO: '',
      KAR_COMENTARIO: '',
      KAR_FECHA: new Date(),
      CENTRA_CODIGO:'',
    };
    // this.encSalidas.push(encSalida);
    this.invsalidaprodService.encsalidaSeleccionada[this.indicador] = encSalida
    this.invsalidaprodService.detkardexsarray[this.indicador] = [];
    this.invsalidaprodService.encordprod=''
    this.invsalidaprodService.encchkcentra=0;
    // this.salidaService.detkardexsvararray[this.indicador] = [];
    document.getElementById('nroComp').focus();
    this.desactivarBotonesNuevo();
    this.invsalidaprodService.calcularTotal();
    
  }
  desactivarBotonesNuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.barraBotones2 = true;
    this.barraBotones4 = false;
  }
  cambio() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonUltimo = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonPrimero = true;
    //CDPJ
    this.botonNuevoP = false;
  }
  cambiarFoco(evento) {
    if (evento.target.id === 'nroComp') {
      document.getElementById('CENTRA_CODIGO').focus();
    } else if(evento.target.id === 'CENTRA_CODIGO'){
      this.busqueCenTrab(evento.target.value)
    }else if (evento.target.id === 'comentario') {
      this.enviarNuevoSalida();
    }
  }
  enviarNuevoSalida() {
    //CDPJ
    this.botonNuevoP = true;
    this.botonRegresarP = false;
    let hora;
    let minutos;
    hora = this.invsalidaprodService.hora.getHours();
    minutos = this.invsalidaprodService.hora.getMinutes();
    if (hora.toString().length === 1) {
      hora = '0' + hora;
    }
    if (minutos.toString().length === 1) {
      minutos = '0' + minutos;
    }
    const hour = hora + ':' + minutos;
    const date = this.datePipe.transform(this.invsalidaprodService.date1, 'dd/MM/yyyy');
    let i = this.invsalidaprodService.detkardexsarray[this.indicador].length + 1;//CDPJ

    const numeroInicial = 1;
    const nuevaSalida = {
      CLAVE: i + this.datePipe.transform(new Date(), 'dd/MM/yyyyHHmmss'),//CDPJ
      // BOD_CODIGO: '',
      ART_CODIGO: '',
      ART_NOMBRE: '',
      KAR_NRO: this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO,
      DETKAR_CANTIDAD: numeroInicial.toFixed(this.decimalesCantidadSal),
      DETKAR_COSTOUNIT: numeroInicial.toFixed(this.decimalesPrecioSal),
      DETKAR_COSTOTOTAL: numeroInicial.toFixed(this.decimalesTotalSal),
      CANTIDAD_DISPONIBLE: 0,
      DETKAR_NRODOC: '',
      CON_CODIGO: '',
      DETKAR_LINEA: 0,
      ENCGRE_CODIGO: '',
      DETGRE_LINEA: '0',
      DETKAR_LOTE: '',
      CLI_CODIGO: '',
      DETKAR_PUNTOS: '0',
      MAEPUN_CODIGO: '',
      DETKAR_CODIGOAUX: '',
      DETKAR_CAJAS: '',
      DETKAR_FRACCIONES: '',
      CANTIDAD_GUARDADA: 0, FECHA: date + '' + hour, HORA: hour,
      CEN_CODIGO: '',//CDPJ
      CENTRA_CODIGO:''

    };
    const indi = this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(this.salidaSeleccionada);
    if (indi === -1) {
      this.invsalidaprodService.detkardexsarray[this.indicador].push(nuevaSalida);
      this.salidaSeleccionada = nuevaSalida;
      this.aggrid.refreshaggrid(this.invsalidaprodService.detkardexsarray[this.indicador], this.defaultColDefSalida.objeto);
      this.invsalidaprodService.calcularTotal();
    } else {
      this.invsalidaprodService.detkardexsarray[this.indicador].splice(indi + 1, 0, nuevaSalida);
      this.salidaSeleccionada = nuevaSalida;
      this.aggrid.refreshaggridindex(this.invsalidaprodService.detkardexsarray[this.indicador], this.defaultColDefSalida.objeto, indi);
      this.invsalidaprodService.calcularTotal();
    }
  }
  seleccionsalida(params) {
    if (params === 'cancelar') {
      //this.enviarCancelarSalida();
      return;
    }
    if (params === 'eliminar') {
      this.verificarBorrarLinea();
      return;
    }
    if (params === 'nuevo') {
      this.enviarNuevoSalida();
      return;
    }
    this.salidaSeleccionada = params.object;
    //this.salidaService.auxsalto = false;
  }
  verificarBorrarLinea() {
    if (this.salidaSeleccionada.KAR_NRO === undefined) {
      this.messageService.add({
        key: 'sal',
        severity: 'info',
        summary: 'Información',
        detail: 'Seleccione la fila que desea eliminar',
      });
    } else {
      this.confirmarBorrarT('registro');
    }
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BUSQUEDA') {
      this.displayDialogBusFast = false;
      this.mostrarDatos(opcion.KAR_NRO);
    }
    if (this.opcion === 'orden') {
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO =opcion.ENCORDPRO_NUMERO
      this.invsalidaprodService.encordprod=opcion.ENCORDPRO_NUMERO
      this.invsalidaprodService.encchkcentra=opcion.ENCORDPRO_CHKCENTRA;
      
      this.displayDialogBusFast = false;
    }
    if (this.opcion === 'CENTROTRAB') {

      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_CODIGO=opcion.CENTRA_CODIGO
      this.invsalidaprodService.encsalidaSeleccionada[this.indicador].CENTRA_DESCRIPCION=opcion.TRNCENTRA_DESCRIPCION;
      document.getElementById('comentario').focus();
      this.displayDialogBusFast = false;
      
    }
  }
  busqueCenTrab(opcion) {
    this.opcion = 'CENTROTRAB';
    this.types = [
      { label: 'Código', value: 'CENTRA_CODIGO' },
      { label: 'Descripción', value: 'TRNCENTRA_DESCRIPCION' }
    ];
    let parametro = isNullOrUndefined(opcion) ? '' : opcion;
    let ordprod = ''
    ordprod = this.invsalidaprodService.encordprod;

    this.busquedaCampos = [parametro, ''];
    //this.consulta = '*';
    this.tabla = 'PROD_MAECENTRA';
    this.where = 'ENCORDPRO_NUMERO=\'' + ordprod + '\' order by CENTRA_CODIGO asc';


    this.busquedaService.busquedaCentrabinvprod(parametro,ordprod).subscribe((eR: any[]) => {
      if (eR !== null) {
        if (Object.keys(eR).length === 1) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaService.busquedaCentrabinvprodparams(parametro,ordprod).subscribe((res: any[]) => {
            if (res !== null && Object.keys(res).length > 0) {

              this.arregloBusq = res;
              this.displayDialogBusFast = true;
            }
          });
        }
      } else {
        this.busquedaService.busquedaCentrabinvprodparams(parametro,ordprod).subscribe((res: any[]) => {
          if (res !== null && Object.keys(res).length > 0) {

            this.arregloBusq = res;
            this.displayDialogBusFast = true;
          }
        });
      }
    });
  }
  busquedaorden() {
    this.opcion = 'orden';
    this.types = [
      { label: 'Orden', value: 'ENCORDPRO_NUMERO' },
      { label: 'Referencia', value: 'ENCORDPRO_REFERENCIA' },
      { label: 'Fecha Emi.', value: 'ENCORDPRO_FECHAEMISION' },
      { label: 'Fecha Inicio', value: 'ENCORDPRO_FECHAINICIO' },
      { label: 'Estado', value: 'ENCORDPRO_ESTADO' }
    ];
    this.busquedaCampos = ['', '', '', '', ''];
    //this.consulta = '*';
    this.tabla = 'PROD_ENCORDPRO';
    this.where = 'ROWNUM < 50';
    this.busquedaService.busquedaNEW().subscribe((datos: any[]) => {
      this.arregloBusq = datos;
      this.arregloBusq.map((registro) => {
        if (registro.ENCORDPRO_FECHAEMISION !== null) {
          registro.ENCORDPRO_FECHAEMISION = this.datePipe.transform(registro.ENCORDPRO_FECHAEMISION, 'dd/MM/yyyy');
        } else {
          registro.ENCORDPRO_FECHAEMISION = '';
        }
        if (registro.ENCORDPRO_FECHAINICIO !== null) {
          registro.ENCORDPRO_FECHAINICIO = this.datePipe.transform(registro.ENCORDPRO_FECHAINICIO, 'dd/MM/yyyy');
        } else {
          registro.ENCORDPRO_FECHAINICIO = '';
        }
      });
      this.displayDialogBusFast = true;
    });
  }
  async insertardatosordpro() {
    try {
      this.displayAcciones = false;
      const elemento = document.getElementsByClassName('layout-config');
      for (let i = 0; i < elemento.length; i++) {
        elemento[i].className = 'layout-config';
      }
      const dato = await this.invsalidaprodService.insertardatosordpro(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO)

      let v_cantidad_por_s = 0
      let v_cantidad_salio = 0
      let coindicendias = 0;
      let costoprom = 0
      let nombreart = ''
      let bodcod = ''
      let cant_disponible = 0
      if (isNullOrUndefined(dato) === false) {
        for (const iterator of dato) {
          nombreart = isNullOrUndefined(iterator.DETORDPRO_DESCRIPCION) ? '' : iterator.DETORDPRO_DESCRIPCION
          bodcod = isNullOrUndefined(iterator.BOD_CODIGO) ? '' : iterator.BOD_CODIGO
          coindicendias = 0
          for (const rs of this.invsalidaprodService.detkardexsarray[this.indicador]) {
            if (rs.ART_CODIGO === iterator.ART_CODIGO) {
              coindicendias++;
            }
          }
          if (coindicendias === 0) {
            this.botonNuevoP = true;
            this.botonRegresarP = false;
            let hora;
            let minutos;
            hora = this.invsalidaprodService.hora.getHours();
            minutos = this.invsalidaprodService.hora.getMinutes();
            if (hora.toString().length === 1) {
              hora = '0' + hora;
            }
            if (minutos.toString().length === 1) {
              minutos = '0' + minutos;
            }
            const hour = hora + ':' + minutos;
            const date = this.datePipe.transform(this.invsalidaprodService.date1, 'dd/MM/yyyy');
            let i = this.invsalidaprodService.detkardexsarray[this.indicador].length + 1;//CDPJ

            const numeroInicial = 1;
            //Verifica si ya esta incluido en otra Entrada
            const data1 = await this.invsalidaprodService.getartsadatosordpro(this.invsalidaprodService.encsalidaSeleccionada[this.indicador].ENCORDPRO_NUMERO, iterator.ART_CODIGO, date, hour, iterator.BOD_CODIGO)
            if (isNullOrUndefined(data1) === false) {
              for (const rs1 of data1) {
                v_cantidad_salio = Number(rs1.CANTIDAD)
                costoprom = Number(rs1.COSTOPROM)
                cant_disponible = Number(rs1.EXISTENCIA)
              }
            }
            v_cantidad_por_s = Number(iterator.DETORDPRO_CANTIDAD) - Number(v_cantidad_salio)

            const nuevaSalida = {
              CLAVE: i + this.datePipe.transform(new Date(), 'dd/MM/yyyyHHmmss'),//CDPJ
              BOD_CODIGO: bodcod,
              ART_CODIGO: iterator.ART_CODIGO,
              ART_NOMBRE: nombreart,
              KAR_NRO: this.invsalidaprodService.encsalidaSeleccionada[this.indicador].KAR_NRO,
              DETKAR_CANTIDAD: v_cantidad_por_s,
              DETKAR_COSTOUNIT: costoprom,
              DETKAR_COSTOTOTAL: numeroInicial.toFixed(this.decimalesTotalSal),
              CANTIDAD_DISPONIBLE: cant_disponible,
              DETKAR_NRODOC: '',
              CON_CODIGO: '',
              DETKAR_LINEA: 0,
              ENCGRE_CODIGO: '',
              DETGRE_LINEA: '0',
              DETKAR_LOTE: '',
              CLI_CODIGO: '',
              DETKAR_PUNTOS: '0',
              MAEPUN_CODIGO: '',
              DETKAR_CODIGOAUX: '',
              DETKAR_CAJAS: '',
              DETKAR_FRACCIONES: '',
              CANTIDAD_GUARDADA: 0, FECHA: date + '' + hour, HORA: hour,
              CEN_CODIGO: '',//CDPJ
              CENTRA_CODIGO:''
            };

            const indi = this.invsalidaprodService.detkardexsarray[this.indicador].indexOf(this.salidaSeleccionada);
            if (indi === -1) {
              this.invsalidaprodService.detkardexsarray[this.indicador].push(nuevaSalida);
              this.salidaSeleccionada = nuevaSalida;
              this.invsalidaprodService.calcularTotal();
              this.aggrid.refreshaggrid(this.invsalidaprodService.detkardexsarray[this.indicador], this.defaultColDefSalida.objeto);

            } else {
              this.invsalidaprodService.detkardexsarray[this.indicador].splice(indi + 1, 0, nuevaSalida);
              this.salidaSeleccionada = nuevaSalida;
              this.invsalidaprodService.calcularTotal();
              this.aggrid.refreshaggridindex(this.invsalidaprodService.detkardexsarray[this.indicador], this.defaultColDefSalida.objeto, indi);

            }
          }

        }
      }

    } catch (error) {


    }

  }
  acciones() {
    this.displayAcciones = !this.displayAcciones;
    const elemento = document.getElementsByClassName('layout-config');
    if (this.displayAcciones === true) {
      for (let i = 1; i <= elemento.length; i++) {
        elemento[i - 1].className += ' layout-config-active';
      }
    } else if (this.displayAcciones === false) {
      for (let i = 1; i <= elemento.length; i++) {
        elemento[i - 1].className = 'layout-config';
      }
    }

  }
  recibirSenalesConEncasil(valor) {
    if (valor === true) {
      this.displayAsiContable = false;
    }
  }
  
}
